module.exports = __webpack_public_path__ + "img/1523618131.c6da1714.jpg";